import React from "react";
import { Search, X } from "lucide-react";
import { Input } from "../ui/input";

/**
 * Reusable filter bar used on every CRUD page.
 * - search: current search string
 * - onSearch: onChange handler
 * - placeholder: input placeholder text
 * - children: optional extra filter controls (Select dropdowns etc.)
 * - count: optional "showing N results" label
 */
export default function FilterBar({
  search,
  onSearch,
  placeholder = "Search…",
  children,
  count,
}) {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-gray-200 bg-white px-4 py-2.5">
      <span className="text-[11px] font-semibold tracking-wider text-gray-400 shrink-0 select-none">
        filters
      </span>
      <div className="relative flex-1 min-w-[180px] max-w-xs">
        <Input
          className="pl-8 h-8 text-[13px]"
          placeholder={placeholder}
          value={search}
          onChange={(e) => onSearch(e.target.value)}
        />
        {search && (
          <button
            onClick={() => onSearch("")}
            className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-300 hover:text-gray-500"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
      {children}
      {count !== undefined && (
        <span className="ml-auto text-[11px] text-gray-400 shrink-0">
          {count} result{count !== 1 ? "s" : ""}
        </span>
      )}
    </div>
  );
}
